import { useEffect, useState } from "react";
import CallAPI from "../api";
import { permission_type } from "../constants";
import Swal from "sweetalert2";
export default function useEmployeeController(canViewList) {
  const [list, setList] = useState([]);
  const [loading, setloading] = useState(false);
  const [account, setaccount] = useState({});
  const [permission, setpermission] = useState({
    [permission_type.CREATE_USER]: false,
    [permission_type.CREATE_EMPLOYEE]: false,
    [permission_type.VIEW_USER_LIST]: false,
    [permission_type.VIEW_EMPLOYEE_LIST]: false,
    [permission_type.VIEW_USER]: false,
    [permission_type.VIEW_EMPLOYEE]: false,
    [permission_type.EDIT_USER]: false,
    [permission_type.EDIT_EMPLOYEE]: false,
  });
  useEffect(() => {
   if(canViewList){
    setloading(true);
    CallAPI("employee/list")
      .then((res) => setList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setloading(false));
   }
  }, []);

  const handleChange = (field, value) => {
    setaccount((prev) => {
      let obj = { ...prev };
      obj[field] = value;
      return obj;
    });
  };

  const handleChangePermission = (field, value) => {
    const cemp=[permission_type.VIEW_EMPLOYEE_LIST,permission_type.VIEW_EMPLOYEE,permission_type.EDIT_EMPLOYEE];
    const cuser=[permission_type.VIEW_USER_LIST,permission_type.VIEW_USER,permission_type.EDIT_USER];
    if(cemp.includes(field)){
      setpermission(prev=>{
        const ind=cemp.indexOf(field);
      
        let obj={...prev};
        if(value)
        for(let i=ind;i>=0;i--)
        obj[cemp[i]]=true;
        else
        for(let i=ind;i<cemp.length;i++)
        obj[cemp[i]]=false;
        return obj;
      })
    }else if(cuser.includes(field)){
      setpermission(prev=>{
        const ind=cuser.indexOf(field);
        let obj={...prev};
        if(value)
        for(let i=ind;i>=0;i--)
        obj[cuser[i]]=true;
        else
        for(let i=ind;i<cuser.length;i++)
        obj[cuser[i]]=false;
        return obj;
      })
    }
    else
    setpermission((prev) => {
      let obj = { ...prev };
      obj[field] = value;
      return obj;
    });
  };
  const create = async () => {
    setloading(true);
    try {
      const data={};
      for(let el in account)
      if(account[el].trim().length!==0)
      data[el]=account[el];
      console.log(data)
      const res = await CallAPI("employee/create", "post", {
        account:data,
        permission,
      });
      setList((prev) => [res.data, ...prev]);
      Swal.fire("success","employee added","success")
    } catch (error) {
      console.log(error);
    }
    setloading(false);
  };

  return {
    list,
    loading,
    account,
    permission,
    handleChange,
    handleChangePermission,
    create,
  };
}
